import { InputRangeNative } from 'components/features/pfm/InputRangeNative/InputRangeNative'
import { MaskedInput, MaskedInputProps, MaskOptions } from 'components/atoms/inputs/maskedInput/MaskedInput/MaskedInput'
import { ChangeEvent, FC, useCallback, useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import styles from 'components/features/creditCard/creditCardComparisonChart/ControlPreset/ControlPreset.styl'
import { SliderTrack } from 'components/features/creditCard/creditCardComparisonChart/SliderTrack/SliderTrack'


type ControlPresetProps = {
  value: number
  mask: MaskOptions
  label: string
  min: number
  max: number
  step: number
  inputMode: MaskedInputProps['inputMode']
  mode: 'spending' | 'performance'
  onChange: (value: number) => void
}
const ControlPreset: FC<ControlPresetProps> = (props) => {
  const { mask, inputMode, value, label, min, max, step, mode, onChange } = props

  const handleRangeChange = useCallback<(event: ChangeEvent<HTMLInputElement>) => void>((event) => {
    onChange(+event.target.value)
  }, [onChange])

  const handleInputChange = useCallback((nextValue: string) => {
    onChange(+nextValue)
  }, [onChange])

  const inputChild = useMemo(() => (
    <MaskedInput
      className={ styles.input }
      value={ `${ value }` }
      options={ mask }
      inputMode={ inputMode }
      onChange={ handleInputChange }
    />
  ), [inputMode, mask, value, handleInputChange])

  return (
    <label>
      <div className={ styles.label }>
        { label }
      </div>
      <div className={ styles.inputWrapper }>
        { inputChild }
        <div className={ styles.units }>
          per<br />month
        </div>
      </div>
      <div className={ styles.rangeWrapper }>
        { mode === 'performance' && (
          <SliderTrack
            className={ styles.track }
            value={ value }
            min={ min }
            max={ max }
          />
        )}
        <InputRangeNative
          value={ value }
          min={ min }
          max={ max }
          step={ step }
          theme={ mode === 'performance' ? 'bigThumbOnly' : 'big' }
          onChange={ handleRangeChange }
        />
      </div>
    </label>
  )
}


export type ControlPresetControllerProps =
  & Omit<ControlPresetProps, 'value' | 'onChange'>
  & {
    name: string
  }
export const ControlPresetController: FC<ControlPresetControllerProps> = (props) => {
  const { name, ...restProps } = props

  const { control } = useFormContext<Record<string, any>>()

  const inputRenderer = useCallback(({ field: { value, onChange }}) => (
    <ControlPreset value={ value } onChange={ onChange } { ...restProps } />
  ), [restProps])

  return (
    <Controller
      control={ control }
      name={ name }
      render={ inputRenderer }
    />
  )
}
